import React, { useContext } from "react";
import "./Login.css";
import Button from "../../../../../components/ButtonComponent/Button";
import vguardlogo from "../../../../../assests/images/vguard_logo.png";
import PlanButton from "../../../../../components/ButtonComponent/PlanButton";
import { LoginOTPContext } from "../Loginview";
const LoginPage = ({ textContents }) => {
  const { loginOtpClik, loginCreditailsClik, tokenNumber } =
    useContext(LoginOTPContext);
  return (
    <div className="loginOTP">
      <div className="loginContainer">
        <div className="col-xl-4 col-lg-5 col-md-5 col-sm-6 col-10 mainBoxEnterOtp">
          <div className="text-center logovgaurd">
            <img src={vguardlogo} />
          </div>
          <div>
            <div className="credentialSubmitloginOTP">
              {tokenNumber !== null && tokenNumber !== 1 && (
                <div>
                  <Button
                    text={textContents.loginOtp}
                    onClick={() => loginOtpClik()}
                  />

                  <div className="oRtext">
                    <h4>{textContents.or}</h4>
                  </div>
                </div>
              )}

              <div>
                <PlanButton
                  text={textContents.loginCredentials}
                  onClick={() => loginCreditailsClik()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
